export const TITLE = 'Your Answer';
export const PLACEHOLDER = 'No answer';
